{
  "it": {
    "issue_status": {
      "actions": {
        "create": "Crea stato segnalazione"
      },
      "labels": {
        "backup_status": "Stato sostitutivo",
        "customer_status": "Il cliente vedrà",
        "delete_status": "Eliminare lo stato \"{name}\"?",
        "delete_status_disclaimer": "Tutte le segnalazioni con questo stato verranno riassegnate allo stato che selezionerà di seguito.",
        "inbox_hint": "Stato predefinito per le segnalazioni in arrivo",
        "internal_status": "Stato interno",
        "new_issue_status": "Stato"
      }
    }
  }
}
